// extracted by mini-css-extract-plugin
export default {"container":"style_container__XUC11","initials":"style_initials__yMXVU"};